import { cellNotFilter, formatDateWithTimeCell, TABLE_CONSTANTS_COLUMS } from "@/shared"
import { EstadoComponente} from "@/shared/components/ui"
import { EstadosSolicitudIngresoEnum, IDataProducto, SolicitudesIngreso } from "@/shared/interfaces"
import { MRT_ColumnDef, MRT_Row, MRT_RowData } from "material-react-table"
import { useMemo, useState } from "react"
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useSinSeriesProducto } from "@/store/erp/productos/sinSeriesProductos.store"
import ModalObservacionGeneral from "@/shared/components/ui/ModalObservacionesGeneral"
import { Button } from "@mui/material"


type useTableColumnsSolicitudIngresoProps = {
  estado: string;
}
type MRT_RowProps<T extends MRT_RowData> = {
  row: MRT_Row<T>;
  //[key: string]: any; // Para otras props que pueda recibir
};
const useTableColumnsSolicitudIngreso = ({ estado }: useTableColumnsSolicitudIngresoProps) => {
  //state
  //const   handleListaProducto= useCargarSeriesProductos(s => s.  handleListaProducto)
  const handleCargarListaProductos = useSinSeriesProducto(s => s.handleCargarListaProductos)
  //const [details, setDetails] = useState<IDataProducto[]>([])
  const [isOpenModal, setIsOpenModal] = useState(false)
  const [isModal1, setIsOpenModal1] = useState(false)

  const color = (estado: string) => {
    switch (estado) {
      case EstadosSolicitudIngresoEnum.ESPERA:
        return '#FFC107';
      case EstadosSolicitudIngresoEnum.APROBADAS:
        return '#28A745';
      case EstadosSolicitudIngresoEnum.RECHAZADO:
        return '#DC3545';
      default:
        return '#6C757D';
    }
  }
  const onDetails = (e: MRT_RowData) => {
    //console.log(e)
    //setDetails(e.productos)
    handleCargarListaProductos(e.productos)
    setIsOpenModal(true)
  }
  const columnsInfo = useMemo<MRT_ColumnDef<SolicitudesIngreso>[]>(
    () => [
      {
        accessorKey: "numero_referencia",
        header: "numero referencia",
      },
      {
        ...cellNotFilter,
        accessorKey: "fecha_creacion",
        header: "fecha de creacion",
        Cell: ({ row }) => formatDateWithTimeCell(row, 'fecha_creacion')
      },

      {
        ...cellNotFilter,
        accessorKey: "bodega_data.nombre",
        header: "bodega",
      },
      {
        ...cellNotFilter,
        accessorKey: "ubicacion_data.nombre",
        header: "ubicacion",
      },
      ...(estado !== EstadosSolicitudIngresoEnum.APROBADAS && estado !== EstadosSolicitudIngresoEnum.RECHAZADO ? [
        {
          ...cellNotFilter,
          accessorKey: "observaciones.observacionSolicitante",
          header: "Observación Solicitante",
          size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
          Cell: ({ row }: MRT_RowProps<SolicitudesIngreso>) => (
            <ModalObservacionGeneral
              texto={row.original.observaciones?.observacionSolicitante || 'N/A'}
              title="Observación solicitante"
            />
          )
        }
      ] : []),
      ...(estado !== EstadosSolicitudIngresoEnum.ESPERA && estado !== EstadosSolicitudIngresoEnum.RECHAZADO ? [
        {
          ...cellNotFilter,
          accessorKey: 'observaciones.observacionRevision',
          header: "observacion del Revisor",
          size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_LARGE,
          Cell: ({ row }: MRT_RowProps<SolicitudesIngreso>) => {
            return (
              <ModalObservacionGeneral
                texto={
                  row.original.observaciones?.observacionRevision || 'N/A'
                }
                title="Observación del Revisor"
              />
            )
          }
        },
      ] : []),
      ...(estado === EstadosSolicitudIngresoEnum.RECHAZADO ? [

        {

          accessorKey: 'motivo_rechazo',
          header: 'Motivo Rechazo',
          size: TABLE_CONSTANTS_COLUMS.COLUMN_WIDTH_SMALL,
          Cell: ({ row }: MRT_RowProps<SolicitudesIngreso>) => {
            return (
              <ModalObservacionGeneral
                texto={
                  row.original.motivo_rechazo || 'N/A'
                }
                title="Motivo"
              />
            )
          }

        }

      ] : []),
      {
        ...cellNotFilter,
        accessorKey: "user.username",
        header: "Usuario",
 
      },
      {
        ...cellNotFilter,
        accessorKey: "estado_solicitud",
        header: "estado",

        Cell: ({ row }) =>
          row.original.estado_solicitud != null ? (
            <EstadoComponente
              backgroundColor={color(estado)}
              texto={row.original.estado_solicitud || ""}
            />
          ) : null,
      },
    ], []
  )
  const columnsSolicitudIngreso = useMemo<MRT_ColumnDef<SolicitudesIngreso>[]>(
    () => [
      {
        ...cellNotFilter,
        enableColumnActions: false,
        accessorKey: "detalle",
        header: "Producto",
        size:100,
        Cell: ({ row }) => {
          return (
            <Button
              variant="text"
              color="primary"
              startIcon={<VisibilityIcon />}
              onClick={() => onDetails(row.original)}
            >
              {'Ver'}
            </Button>
          )
        }

      },
      ...columnsInfo
    ], []

  )

  const columnsInfoProducto = useMemo<MRT_ColumnDef<IDataProducto>[]>(
    () => [
      {
        accessorKey: 'codigo',
        header: 'Código',
        Cell: ({ row }) => row.original?.codigo || 'N/A',
      },
      {
        accessorKey: 'producto_data.descripcion',
        header: 'Descripción',
      },
      {
        accessorKey: 'producto_data.unidad_medida',
        header: 'Unidad Medida',
        Cell: ({ row }: any) => row.original.producto_data?.unidad_medida || 'N/A'
      },
      {
        accessorKey: 'producto_data.modelo_producto',
        header: 'Modelo',
      },
      {
        accessorKey: 'producto_data.marca_producto',
        header: 'Marca',
      },
      {
        accessorKey: 'producto_data.categoria_producto',
        header: 'Categoria',
      },

      {
        accessorKey: 'cantidad',
        header: 'Cant. Solicitada'
      },
    ], []
  )
  const columnsInfoFinalizado = useMemo<MRT_ColumnDef<SolicitudesIngreso>[]>(
    () => [
      {
        accessorKey: 'motivo_rechazo',
        header: 'Motivo Rechazo'
      },
      ...columnsInfo
    ], []
  )

  return {
    columnsSolicitudIngreso,
    columnsInfoProducto,
    columnsInfoFinalizado,
    //details,
    isOpenModal,
    setIsOpenModal,
    isModal1,
    setIsOpenModal1
  }
}
export default useTableColumnsSolicitudIngreso